import './style.scss';
import Builder from './Components/DynamicFormBuilderScreen';
import LfaScreen from './Components/LfaScreen';
import LeoChatScreen from './Components/LeoChatScreen';
import MakeReadyBoard from './Components/MakeReadyBoard';
import History from './Services/History';
import './react-components';

History.init();
